(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarse = window.matchMedia('(pointer: coarse)').matches;

  function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }

  var rescanners = [];
  function rescannable(fn) { rescanners.push(fn); fn(); }
  document.addEventListener('aries:rendered', function () {
    for (var i = 0; i < rescanners.length; i++) rescanners[i]();
  });

  function claim(el, key) {
    var flag = 'bound' + key;
    if (el.dataset[flag]) return false;
    el.dataset[flag] = '1';
    return true;
  }

  function smooth(t) { t = clamp(t, 0, 1); return t * t * (3 - 2 * t); }

  function span(v, a, b) { return clamp((v - a) / (b - a), 0, 1); }

  function Spring(k, c, value) {
    this.k = k; this.c = c;
    this.x = value || 0;
    this.v = 0;
    this.target = this.x;
  }

  Spring.prototype.step = function (dt) {

    var remaining = Math.min(dt, 0.05);
    while (remaining > 0) {
      var h = Math.min(remaining, 1 / 240);
      remaining -= h;
      var a = -this.k * (this.x - this.target) - this.c * this.v;
      this.v += a * h;
      this.x += this.v * h;
    }
    return this.x;
  };

  Spring.prototype.atRest = function () {
    return Math.abs(this.x - this.target) < 0.0005 && Math.abs(this.v) < 0.0015;
  };

  function Stage() {
    this.acts = [];
    this.writers = [];
    this.lastT = 0;
    this.scrollY = window.scrollY;
    this.vh = window.innerHeight;
    this.docLen = 1;
    this.awake = true;
  }

  Stage.prototype.act = function (el, handler) {
    if (!el) return;
    this.acts.push({ el: el, handler: handler, last: -1 });
  };

  Stage.prototype.write = function (fn) { this.writers.push(fn); };

  Stage.prototype.measureDoc = function () {
    this.vh = window.innerHeight;
    this.docLen = Math.max(1, document.documentElement.scrollHeight - this.vh);
  };

  Stage.prototype.start = function () {
    var self = this;

    this.measureDoc();
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { self.measureDoc(); }, 150);
    });

    document.addEventListener('visibilitychange', function () {
      self.awake = !document.hidden;
      if (self.awake) {
        self.lastT = performance.now();
        requestAnimationFrame(tick);
      }
    });

    function tick(t) {
      if (!self.awake) return;
      var dt = (t - self.lastT) / 1000;
      self.lastT = t;
      if (dt > 0.5) dt = 1 / 60;

      self.scrollY = window.scrollY;

      for (var i = 0; i < self.acts.length; i++) {
        var a = self.acts[i];
        var rect = a.el.getBoundingClientRect();
        var travel = rect.height - self.vh;

        a.progress = travel > 4
          ? clamp(-rect.top / travel, 0, 1)
          : clamp(-rect.top / self.vh, 0, 1);

        a.live = rect.top < self.vh && rect.bottom > 0;
      }

      for (var j = 0; j < self.acts.length; j++) {
        var act = self.acts[j];
        if (!act.live && act.progress === act.last) continue;
        act.last = act.progress;
        act.handler(act.progress, act.live, dt);
      }

      for (var w = 0; w < self.writers.length; w++) self.writers[w](dt);

      requestAnimationFrame(tick);
    }

    this.lastT = performance.now();
    requestAnimationFrame(tick);
  };

  function furniture(stage) {
    var rail = document.querySelector('[data-progress]');
    var lastRail = -1;

    stage.write(function () {
      if (rail) {
        var p = Math.round(clamp(stage.scrollY / stage.docLen, 0, 1) * 1000) / 1000;
        if (p !== lastRail) {
          lastRail = p;
          rail.style.transform = 'scaleX(' + p + ')';
        }
      }
    });

    var noObserver = !('IntersectionObserver' in window) || reduced;
    var io = noObserver ? null : new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var d = parseFloat(e.target.getAttribute('data-reveal')) || 0;
        e.target.style.transitionDelay = d + 'ms';
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    rescannable(function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-reveal]'), function (el) {
        if (!claim(el, 'Reveal')) return;
        if (io) io.observe(el);
        else el.classList.add('is-in');
      });
    });
  }

  function airCursor(stage) {
    if (coarse || reduced) return;

    var el = document.createElement('div');
    el.className = 'air';
    el.setAttribute('aria-hidden', 'true');
    document.body.appendChild(el);

    var tx = window.innerWidth / 2, ty = window.innerHeight / 2;
    var x = tx, y = ty, on = false;

    window.addEventListener('pointermove', function (e) {
      tx = e.clientX; ty = e.clientY;
      if (!on) { on = true; x = tx; y = ty; el.setAttribute('data-on', ''); }
    }, { passive: true });

    document.addEventListener('pointerleave', function () {
      on = false;
      el.removeAttribute('data-on');
    });

    stage.write(function (dt) {
      if (!on) return;

      var f = 1 - Math.pow(0.0016, dt);
      x += (tx - x) * f;
      y += (ty - y) * f;
      el.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
    });
  }

  function magnets(stage) {
    if (coarse || reduced) return;

    var pull = 22;
    var give = 0.32;

    Array.prototype.forEach.call(document.querySelectorAll('[data-magnetic]'), function (el) {
      var sx = new Spring(210, 22), sy = new Spring(210, 22);
      var near = false;

      window.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        var dx = e.clientX - cx, dy = e.clientY - cy;
        near = Math.abs(dx) < r.width / 2 + pull && Math.abs(dy) < r.height / 2 + pull;
        sx.target = near ? dx * give : 0;
        sy.target = near ? dy * give : 0;
      }, { passive: true });

      stage.write(function (dt) {
        if (sx.atRest() && sy.atRest()) return;
        el.style.transform =
          'translate3d(' + sx.step(dt).toFixed(2) + 'px,' + sy.step(dt).toFixed(2) + 'px,0)';
      });
    });
  }

  function springWord(stage, el) {
    if (!el) return;

    var s = new Spring(150, 13);
    var dragging = false, startY = 0, hovering = false;
    var vw = window.innerWidth;

    function trackMax() { return vw < 760 ? 0.14 : 0.4; }
    window.addEventListener('resize', function () { vw = window.innerWidth; });

    function set(v) { s.target = clamp(v, 0, 1); }

    var HOVER = 0.45;

    el.addEventListener('pointerenter', function () {
      hovering = true;
      if (!dragging) set(HOVER);
    });
    el.addEventListener('pointerleave', function () {
      hovering = false;
      if (!dragging) set(0);
    });

    el.addEventListener('pointerdown', function (e) {
      dragging = true;
      startY = e.clientY;
      el.setPointerCapture(e.pointerId);
      el.setAttribute('data-pulling', '');
    });

    el.addEventListener('pointermove', function (e) {
      if (!dragging) return;

      set((e.clientY - startY) / 260);
    });

    function release() {
      if (!dragging) return;
      dragging = false;
      el.removeAttribute('data-pulling');
      set(hovering ? HOVER : 0);
    }
    el.addEventListener('pointerup', release);
    el.addEventListener('pointercancel', release);

    if (reduced) return;

    var lastW = -1;
    stage.write(function (dt) {
      if (s.atRest() && s.x === lastW) return;
      var x = s.step(dt);
      lastW = x;

      var wght = 700 - 300 * x;
      el.style.fontVariationSettings = "'wght' " + wght.toFixed(0);
      el.style.letterSpacing = (-0.028 + trackMax() * x).toFixed(4) + 'em';

      el.style.setProperty('--tension', x.toFixed(3));
    });
  }

  function stageOn(el, ms, done) {
    var fired = false;
    function go() { if (fired) return; fired = true; done(); }
    if (el) el.addEventListener('animationend', go, { once: true });
    setTimeout(go, ms);
  }

  function releaseChain(hero, sub) {
    if (!hero) return function () {};
    var pull = hero.querySelector('.hero__pull');
    var cta = hero.querySelector('.hero__cta');

    function say() {
      hero.setAttribute('data-said', '');

      stageOn(pull, 1000, function () { hero.setAttribute('data-urged', ''); });
    }

    if (!sub || reduced) { say(); return function () {}; }
    return say;
  }

  function subheadLetters(el, after, then) {
    if (!el) { if (then) then(); return; }

    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) { if (then) then(); return; }

    var sentences = text.match(/[^.!?]+[.!?]*/g) || [];
    if (!sentences.length) { if (then) then(); return; }

    el.textContent = '';

    var spoken = document.createElement('span');
    spoken.className = 'visually-hidden';
    spoken.textContent = text;
    el.appendChild(spoken);

    var n = 0;
    sentences.forEach(function (raw) {
      var sentence = raw.trim();
      if (!sentence) return;

      var line = document.createElement('span');
      line.className = 'hero__sub-line';
      line.setAttribute('aria-hidden', 'true');

      sentence.split(' ').forEach(function (word, i) {
        if (i) line.appendChild(document.createTextNode(' '));
        var box = document.createElement('span');
        box.className = 'hero__sub-word';
        for (var c = 0; c < word.length; c++) {
          var ch = document.createElement('span');
          ch.className = 'hero__sub-ch';
          ch.style.setProperty('--i', n++);
          ch.textContent = word.charAt(c);
          box.appendChild(ch);
        }
        line.appendChild(box);
      });

      n += 6;
      el.appendChild(line);
    });

    function play() {
      el.setAttribute('data-typing', '');
      if (!then) return;

      var letters = el.querySelectorAll('.hero__sub-ch');
      var last = letters[letters.length - 1];
      var cs = getComputedStyle(el);
      var step = parseFloat(cs.getPropertyValue('--letter-step')) || 20;
      var fade = parseFloat(cs.getPropertyValue('--letter-fade')) || 700;
      stageOn(last, n * step + fade + 400, then);
    }

    if (!after || reduced) { play(); return; }

    var done = false;
    function go() {
      if (done) return;
      done = true;
      play();
    }

    after.addEventListener('animationend', go, { once: true });

    function arm(held) {
      var cs = getComputedStyle(after);
      if (cs.animationPlayState === 'paused') {
        setTimeout(function () { arm(true); }, 150);
        return;
      }

      var ends = (parseFloat(cs.animationDelay) + parseFloat(cs.animationDuration)) * 1000;
      var wait = held ? ends : Math.max(0, (ends || 0) - performance.now());
      setTimeout(go, wait + 80);
    }
    arm(false);
  }

  function heroAct(stage, el) {
    if (!el) return;
    var type = el.querySelector('[data-hero-type]');
    if (reduced) return;

    stage.act(el, function (p) {
      if (!type) return;

      if (tall(el)) {
        if (type.style.transform) { type.style.transform = ''; type.style.opacity = ''; }
        return;
      }

      var e = smooth(p);
      type.style.transform = 'translate3d(0,' + (-e * 88).toFixed(1) + 'px,0)';
      type.style.opacity = (1 - span(p, 0.35, 0.92)).toFixed(3);
    });
  }

  function tall(el) {
    return el.getBoundingClientRect().height > window.innerHeight + 8;
  }

  function typeGate(el) {
    if (!el) return;
    var type = el.querySelector('[data-hero-type]');
    if (!type) return;

    function release() { el.setAttribute('data-type-in', ''); }

    if (reduced || !('IntersectionObserver' in window) || !tall(el)) {
      release();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        release();
        io.disconnect();
        return;
      }
    }, { threshold: 0.35 });
    io.observe(type);

    window.addEventListener('resize', function () {
      if (!tall(el)) { release(); io.disconnect(); }
    }, { passive: true });
  }

  function pageTurn(stage, heroEl, reelEl) {
    if (!heroEl || !reelEl || document.querySelector('[data-diffuser-benefits]')) return;

    var TURN = 620;

    var COOL = 160;

    var TAIL = 1100;

    var ARM = 18;

    var LIP = 24;

    var animating = false, from = 0, to = 0, t0 = 0, until = 0, hardStop = 0;
    var acc = 0, accAt = 0;
    var touching = false, touchDir = 0, touchY = 0;
    var stillY = -1, stillFor = 0, lastDir = 1;

    function edge() {
      return Math.round(reelEl.getBoundingClientRect().top + window.scrollY);
    }

    function stops() {
      var r = heroEl.getBoundingClientRect();
      var top = Math.round(r.top + window.scrollY);
      var out = [top];

      var second = Math.round(r.bottom + window.scrollY - window.innerHeight);
      if (second > top + window.innerHeight * 0.5) out.push(second);
      var b = edge();
      if (b > out[out.length - 1] + 8) out.push(b);
      return out;
    }

    function armed() {
      var s = stops();
      for (var i = 1; i < s.length; i++) {
        if (s[i] - s[i - 1] > window.innerHeight + 8) return false;
      }
      return true;
    }

    function busy() {

      if (animating && performance.now() - t0 > TURN * 3) {
        window.scrollTo({ top: to, behavior: 'instant' });
        animating = false;
        until = 0;
      }
      return animating || performance.now() < until;
    }

    function turnTo(y) {
      acc = 0;
      if (y === window.scrollY) return;
      lastDir = y > window.scrollY ? 1 : -1;
      if (reduced) {
        window.scrollTo({ top: y, behavior: 'instant' });
        until = performance.now() + COOL;
        hardStop = until + TAIL;
        return;
      }
      from = window.scrollY; to = y; t0 = performance.now();
      hardStop = t0 + TURN + TAIL;
      animating = true;
    }

    function decide(dir) {
      var s = stops(), y = window.scrollY, i;

      if (dir > 0) {
        for (i = 0; i < s.length; i++) if (s[i] > y + 1) return s[i];
        return null;
      }

      if (y <= 1) return null;

      var k = 0;
      for (i = s.length - 1; i >= 0; i--) if (y >= s[i] - 1) { k = i; break; }

      if (y < s[k] + LIP) return k > 0 ? s[k - 1] : null;
      return k === s.length - 1 ? null : s[k];
    }

    function settled(y) {
      var s = stops();
      for (var i = 0; i < s.length; i++) if (Math.abs(y - s[i]) <= 2) return true;
      return y > s[s.length - 1];
    }

    window.addEventListener('wheel', function (e) {
      if (!armed() || e.ctrlKey) return;
      if (busy()) {
        e.preventDefault();
        until = Math.min(hardStop, Math.max(until, performance.now() + COOL));
        return;
      }

      var d = e.deltaY * (e.deltaMode === 1 ? 40 : e.deltaMode === 2 ? window.innerHeight : 1);
      if (!d) return;

      var target = decide(d);
      if (target === null) { acc = 0; return; }
      e.preventDefault();

      var now = performance.now();
      if (now - accAt > 250 || (acc > 0) !== (d > 0)) acc = 0;
      accAt = now;
      acc += d;
      if (Math.abs(acc) >= ARM) turnTo(target);
    }, { passive: false });

    var KEYS = {
      ArrowDown: 1, PageDown: 1, ' ': 1, Spacebar: 1,
      ArrowUp: -1, PageUp: -1,
    };
    window.addEventListener('keydown', function (e) {
      if (!armed() || e.metaKey || e.ctrlKey || e.altKey) return;
      var dir = KEYS[e.key];
      if (!dir) return;
      var t = e.target;
      if (t && (/^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName) || t.isContentEditable)) return;
      if (busy()) { e.preventDefault(); return; }
      var target = decide(dir);
      if (target === null) return;
      e.preventDefault();
      turnTo(target);
    });

    window.addEventListener('touchstart', function (e) {
      touching = true; touchDir = 0;
      touchY = e.touches[0].clientY;
    }, { passive: true });

    window.addEventListener('touchmove', function (e) {
      var y = e.touches[0].clientY;
      if (Math.abs(y - touchY) > 2) touchDir = y < touchY ? 1 : -1;
      touchY = y;
    }, { passive: true });

    function release() {
      touching = false;
      if (!armed() || busy()) return;

      if (!touchDir) return;
      var target = decide(touchDir);
      if (target !== null) turnTo(target);
    }
    window.addEventListener('touchend', release, { passive: true });
    window.addEventListener('touchcancel', release, { passive: true });

    stage.write(function (dt) {
      if (animating) {
        var t = clamp((performance.now() - t0) / TURN, 0, 1);
        window.scrollTo({ top: Math.round(from + (to - from) * smooth(t)), behavior: 'instant' });
        if (t === 1) { animating = false; until = performance.now() + COOL; }
        return;
      }

      if (touching || !armed()) { stillFor = 0; return; }
      var y = window.scrollY;
      if (settled(y)) { stillFor = 0; stillY = y; return; }

      if (y !== stillY) { lastDir = y > stillY ? 1 : -1; stillY = y; stillFor = 0; return; }
      stillFor += dt;
      if (stillFor > 0.18) {
        stillFor = 0;
        var target = decide(lastDir);
        if (target !== null) turnTo(target);
      }
    });
  }

  function reelAct(stage, el, mount) {
    if (!el) return;

    var reel = null;
    var root = document.documentElement;
    var tinted = false;

    var resetSlot = function () {};

    function actTop() { return el.getBoundingClientRect().top + window.scrollY; }
    function actTravel() { return el.offsetHeight - window.innerHeight; }

    function tint(hex) {
      if (!hex) return;
      root.style.setProperty('--curl', hex);
    }

    var PER_PRODUCT = 3;

    function stepCount() {
      return Math.max(1, reel.n * PER_PRODUCT - 1);
    }

    function sizeFor(model) {
      el.style.setProperty('--reel-steps', Math.max(1, model.colorways.length * PER_PRODUCT - 1));
      sizeColumns();
      stage.measureDoc();
    }

    var sideProbe = el.querySelector('.reel__id');
    var reelRoot = el.querySelector('.reel-root');
    var stacked = window.matchMedia('(orientation: portrait), (max-width: 760px)');

    var COL_GAP = 10;
    var MIN_SIDE = 176;

    var MAX_SIDE = 4000;

    var MIN_BAND = 2 * 0.94 * 16.8;

    function columnsFor(ratio) {

      var gutter = sideProbe.getBoundingClientRect().left;
      var stageW = el.clientWidth;
      var centre = stageW - 2 * (gutter + MIN_SIDE + COL_GAP);
      var card = el.querySelector('.card');
      if (card) {
        var cs = getComputedStyle(card);
        var pad = parseFloat(cs.paddingLeft);
        var boxH = card.clientHeight -
          parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
        centre = Math.min(centre, boxH / ratio + 2 * pad);
      }
      centre = Math.max(160, Math.round(centre));
      var side = Math.min(MAX_SIDE, Math.round((stageW - centre) / 2) - gutter - COL_GAP);
      return { centre: centre, side: Math.max(MIN_SIDE, side) };
    }

    function sizeColumns() {
      if (!sideProbe || !reelRoot || stacked.matches) {
        el.style.removeProperty('--card-w');
        el.style.removeProperty('--side');
        el.style.removeProperty('--slogan-band');

        el.style.removeProperty('--name-band');
        el.style.removeProperty('--name-room');

        if (reelRoot) reelRoot.removeAttribute('data-cramped');
        return;
      }

      var shot = el.querySelector('.card img[src]');

      if (shot && !shot.naturalHeight) {
        shot.addEventListener('load', sizeColumns, { once: true });
      }
      var cols = columnsFor(shot && shot.naturalHeight
        ? shot.naturalHeight / shot.naturalWidth
        : 2.42);
      el.style.setProperty('--card-w', cols.centre + 'px');

      el.style.setProperty('--side', cols.side + 'px');

      var rows = getComputedStyle(reelRoot).gridTemplateRows.split(' ');
      if (rows.length < 3) return;
      el.style.setProperty('--slogan-band', rows[2]);

      if (rows.length >= 5) {
        var gap = parseFloat(getComputedStyle(reelRoot).rowGap) || 0;
        var free = reelRoot.clientHeight - parseFloat(rows[0]) -
                   parseFloat(rows[3]) - parseFloat(rows[4]) - 3 * gap;
        el.style.setProperty('--name-band', Math.max(0, free).toFixed(2) + 'px');
      }

      var metaEl = el.querySelector('.reel__meta');
      var shotEl = el.querySelector('.card');
      if (metaEl && shotEl) {
        var cpad = parseFloat(getComputedStyle(shotEl).paddingLeft) || 0;
        var air = Math.min(Math.max(12, el.clientWidth * 0.016), 32);
        var room = metaEl.getBoundingClientRect().right -
                   (el.clientWidth / 2 + 0.48 * (cols.centre - 2 * cpad)) - air;
        el.style.setProperty('--name-room', Math.max(0, room).toFixed(2) + 'px');
      }

      var band = parseFloat(rows[2]);
      reelRoot.toggleAttribute('data-cramped', band < MIN_BAND);
    }

    var szt;
    window.addEventListener('resize', function () {
      clearTimeout(szt);
      szt = setTimeout(sizeColumns, 160);
    });
    if (stacked.addEventListener) stacked.addEventListener('change', sizeColumns);

    var notches = [];
    var learned = 0;
    var pendingStep = 0;

    function applyStep(px) {
      pendingStep = 0;
      learned = px;
      el.style.setProperty('--reel-step', px + 'px');
      stage.measureDoc();
    }

    window.addEventListener('wheel', function (e) {
      if (e.deltaMode === 2) return;
      var px = Math.abs(e.deltaY) * (e.deltaMode === 1 ? 40 : 1);
      if (px < 40 || px > 400) return;
      notches.push(px);
      if (notches.length > 9) notches.shift();
      if (notches.length < 4) return;

      var sorted = notches.slice().sort(function (a, b) { return a - b; });
      var median = Math.round(clamp(sorted[sorted.length >> 1], 45, 220));
      if (Math.abs(median - learned) < 4) return;

      if (tinted) pendingStep = median;
      else applyStep(median);
    }, { passive: true });

    reel = mount({
      driven: true,

      onModel: function (model, initial) {
        sizeFor(model);

        resetSlot(0);

        if (!initial) {
          var top = actTop();
          if (window.scrollY > top) window.scrollTo({ top: top + 2, behavior: 'auto' });
        }
      },

      onColor: function (hex) { if (tinted) tint(hex); },

      onJump: function (i) {
        window.scrollTo({
          top: actTop() + (i * PER_PRODUCT / stepCount()) * actTravel(),
          behavior: reduced ? 'auto' : 'smooth',
        });
      },
    });

    if (!reel) return;

    var slot = new Spring(200, 28);
    var lastIdx = -1;
    resetSlot = function (i) {
      slot.x = slot.target = lastIdx = i || 0;
      slot.v = 0;
    };

    stage.act(el, function (p, live, dt) {
      if (live !== tinted) {
        tinted = live;
        tint(live ? reel.tint : root.style.getPropertyValue('--curl-hero').trim());

        if (live) {
          resetSlot(Math.min(reel.n - 1, Math.floor(Math.round(p * stepCount()) / PER_PRODUCT)));

          sizeColumns();
        }

        else if (pendingStep) applyStep(pendingStep);
      }
      if (!live) return;

      var step = Math.round(p * stepCount());
      var idx = Math.min(reel.n - 1, Math.floor(step / PER_PRODUCT));

      if (idx !== lastIdx) {
        lastIdx = idx;
        slot.target = idx;
      }

      var pos = reduced ? (slot.x = slot.target) : slot.step(dt);
      reel.drive(reel.n > 1 ? pos / (reel.n - 1) : 0);
    });
  }

  function jumpLinks() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var target = document.getElementById(a.getAttribute('href').slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    });
  }

  window.AriesStage = {

    init: function (opts) {
      opts = opts || {};
      var stage = new Stage();

      if (location.hash) {
        history.replaceState(null, '', location.pathname + location.search);
        window.scrollTo(0, 0);
      }

      jumpLinks();

      var heroEl = document.querySelector('[data-act="hero"]');

      furniture(stage);
      airCursor(stage);
      magnets(stage);

      heroAct(stage, heroEl);
      typeGate(heroEl);

      Array.prototype.forEach.call(
        document.querySelectorAll('[data-spring]'),
        function (word) { springWord(stage, word); }
      );
      var reelEl = document.querySelector('[data-act="reel"]');
      pageTurn(stage, heroEl, reelEl);
      if (opts.mountReel) {
        reelAct(stage, reelEl, opts.mountReel);
      }

      stage.start();
      return stage;
    },

    Spring: Spring,
  };

  (function () {
    var hero = document.querySelector('.hero');
    var sub = document.querySelector('[data-letters]');
    subheadLetters(sub, document.querySelector('.hero__title em'),
                   releaseChain(hero, sub));
  })();

  function lockupJump() {
    var mark = document.querySelector('.partner__of');
    var target = document.getElementById('reel');
    if (!mark || !target) return;

    var portrait = window.matchMedia('(orientation: portrait)');
    var label = null;

    function on() {
      if (label) return;
      mark.setAttribute('role', 'button');
      mark.setAttribute('tabindex', '0');
      mark.setAttribute('data-jump', '');
      label = document.createElement('span');
      label.className = 'visually-hidden';
      label.textContent = mark.getAttribute('data-jump-label') || 'Scroll down';
      mark.appendChild(label);
    }

    function off() {
      if (!label) return;
      mark.removeAttribute('role');
      mark.removeAttribute('tabindex');
      mark.removeAttribute('data-jump');
      label.remove();
      label = null;
    }

    function apply() { portrait.matches ? on() : off(); }
    apply();

    if (portrait.addEventListener) portrait.addEventListener('change', apply);
    else if (portrait.addListener) portrait.addListener(apply);

    function go() {
      if (!portrait.matches) return;
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    }

    mark.addEventListener('click', go);
    mark.addEventListener('keydown', function (e) {

      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        go();
      }
    });
  }

  function hitDistance(gap, vw) {
    var cap = vw * 0.1;

    var cap2 = Math.max(cap, 1);
    var min = Math.min(26, cap2);
    var d = Math.max(min, Math.min(cap2, Math.abs(gap)));
    return gap < 0 ? -d : d;
  }

  function measureFlight(el, dir, wallFor, squash) {
    if (!el) return;
    var vw = window.innerWidth;
    var r = el.getBoundingClientRect();
    if (!r.width && !r.height) return;

    var wall = wallFor(r, vw);
    var gap = dir === 'left' ? wall - r.left : wall - r.right;

    el.style.setProperty('--fly-hit', hitDistance(gap, vw).toFixed(1) + 'px');
    el.style.setProperty('--fly-from',
      (dir === 'left' ? (vw - r.left + 40) : -(r.right + 40)).toFixed(0) + 'px');
    if (squash) el.style.setProperty('--fly-squash', String(squash));
  }

  function withoutFlights(fn) {
    var root = document.documentElement;
    root.setAttribute('data-measuring', '');

    void root.offsetWidth;
    try { fn(); } finally { root.removeAttribute('data-measuring'); }
  }

  function flightsHaveStarted() {
    if (!document.documentElement.getAnimations) return false;
    var els = document.querySelectorAll('.hero__title-pink, .hero__title em,' +
                                        '.partner__mark, .partner__of');
    for (var i = 0; i < els.length; i++) {
      var anims = els[i].getAnimations ? els[i].getAnimations() : [];
      for (var j = 0; j < anims.length; j++) {
        if (anims[j].animationName === 'fly-bounce' && anims[j].currentTime > 0) return true;
      }
    }
    return false;
  }

  function heroPhotoBox() {
    var shot = document.querySelector('.hero__shot');
    if (!shot) return null;
    var cs = getComputedStyle(shot);
    if (cs.display === 'none' || cs.position === 'static') return null;
    var r = shot.getBoundingClientRect();
    return r.width ? r : null;
  }

  function measureHeadlineFlights() {
    var photo = heroPhotoBox();

    measureFlight(document.querySelector('.hero__title-pink'), 'right',
      function (r, vw) { return photo && photo.left > r.right ? photo.left : vw; }, 0.94);

    measureFlight(document.querySelector('.hero__title em'), 'left',
      function (r) { return photo && photo.right < r.left ? photo.right : 0; }, 0.94);
  }

  function measureLockupFlights() {

    if (!window.matchMedia('(orientation: landscape) and (min-width: 961px),' +
                           '(orientation: landscape) and (max-height: 620px)').matches) return;

    measureFlight(document.querySelector('.partner__mark'), 'left',
      function () { return 0; }, 0.86);

    var line = document.querySelector('.partner__line');
    measureFlight(document.querySelector('.partner__of'), 'left',
      function (r) {
        var lr = line && line.getBoundingClientRect();
        return lr && lr.right < r.left ? lr.right : 0;
      }, 0.86);
  }

  function measureFlights() {
    if (reduced) return;
    withoutFlights(function () {
      measureHeadlineFlights();
      measureLockupFlights();
    });
  }

  lockupJump();

  measureFlights();
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      if (!flightsHaveStarted()) measureFlights();
    });
  }

  window.addEventListener('resize', function () {
    if (!flightsHaveStarted()) measureFlights();
  });

  function lockupLetters(el) {
    if (!el) return;
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return;

    el.textContent = '';

    var spoken = document.createElement('span');
    spoken.className = 'visually-hidden';
    spoken.textContent = text;
    el.appendChild(spoken);

    var shown = document.createElement('span');
    shown.setAttribute('aria-hidden', 'true');

    var n = 0;
    text.split(' ').forEach(function (word, i) {
      if (i) shown.appendChild(document.createTextNode(' '));
      var box = document.createElement('span');
      box.className = 'lockup-word';
      for (var c = 0; c < word.length; c++) {
        var ch = document.createElement('span');
        ch.className = 'lockup-ch';
        ch.style.setProperty('--i', n++);
        ch.textContent = word.charAt(c);
        box.appendChild(ch);
      }
      shown.appendChild(box);
    });

    el.appendChild(shown);
  }

  lockupLetters(document.querySelector('.partner__name'));
  lockupLetters(document.querySelector('.partner__line'));
})();
